// Voice-Display + Color-Mapping. Pure functions — input ist immer asset.voiceIds
// (für Spur-Index) + config.voices (für Display-Name). Mapping ist 0-indiziert
// → 1-basierte UI-Nummer; --voice-1/2/3 Tokens werden aus tokens.css gelesen.

import type { Voice } from '@shared/types';

const VOICE_VARS = ['var(--voice-1)', 'var(--voice-2)', 'var(--voice-3)'] as const;

/** CSS-Variable für die Voice. Stale voiceId (nicht in asset.voiceIds)
 *  → var(--muted) als Fallback-Indicator. */
export function voiceColorVar(voiceId: string, assetVoiceIds: string[]): string {
  const idx = assetVoiceIds.indexOf(voiceId);
  if (idx < 0 || idx >= VOICE_VARS.length) return 'var(--muted)';
  return VOICE_VARS[idx];
}

/** Kompakter Chip-Label "Voice 1" / "Voice 2" / "Voice 3" oder "Voice ?". */
export function voiceLabel(voiceId: string, assetVoiceIds: string[]): string {
  const idx = assetVoiceIds.indexOf(voiceId);
  if (idx < 0) return 'Voice ?';
  return `Voice ${idx + 1}`;
}

/** Dropdown-Option "1 — DZ Bank Brandvoice". Stale voiceId → "? — unknown". */
export function voiceDisplayName(
  voiceId: string,
  assetVoiceIds: string[],
  voices: Voice[],
): string {
  const idx = assetVoiceIds.indexOf(voiceId);
  if (idx < 0) return '? — unknown';
  const v = voices.find((x) => x.id === voiceId);
  return `${idx + 1} — ${v?.name ?? 'unknown'}`;
}

/** Reine Voice-Position-Number, 0-basiert. -1 für stale. */
export function voiceTrackIndex(voiceId: string, assetVoiceIds: string[]): number {
  const idx = assetVoiceIds.indexOf(voiceId);
  return idx < 0 ? -1 : idx;
}
